/**
 * 🛒💜 PORTAL LOADER - Animation de chargement
 * Caddy qui bat comme un cœur !
 */

import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Heart } from 'lucide-react';

const PortalLoader = () => {
  return (
    <div 
      className="min-h-screen overflow-x-hidden overflow-y-auto flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, #0a0015 0%, #1a0033 50%, #0a0015 100%)',
      }}
    >
      <motion.div 
        className="text-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* 🛒💜 CADDY QUI BAT COMME UN CŒUR - LOADER MAGNÉTIQUE ! */}
        <motion.div
          className="relative mx-auto mb-6"
          animate={{
            scale: [1, 1.15, 1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <ShoppingBag 
            className="w-20 h-20 text-cyan-400 mx-auto" 
            style={{
              filter: 'drop-shadow(0 0 30px rgba(0, 255, 255, 0.8)) drop-shadow(0 0 50px rgba(255, 0, 255, 0.4))'
            }}
          />
          {/* Petit cœur qui pulse sur le caddy */}
          <motion.div
            animate={{
              scale: [1, 1.4, 1],
              opacity: [0.8, 1, 0.8]
            }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="absolute top-0 right-1/4"
          >
            <Heart className="w-6 h-6 text-pink-500 fill-pink-500" style={{
              filter: 'drop-shadow(0 0 10px rgba(236, 72, 153, 0.8))'
            }} />
          </motion.div>
        </motion.div>
        
        {/* Texte animé */}
        <motion.p 
          className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400 mb-2"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          La Petite Épicerie
        </motion.p>
        <motion.p 
          className="text-gray-400 text-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Ton magasin de quartier arrive... 💜
        </motion.p>
        
        {/* Barre de chargement stylée */}
        <div className="w-48 h-1 bg-gray-800 rounded-full mx-auto mt-4 overflow-hidden">
          <motion.div
            className="h-full bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 rounded-full"
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: 2, ease: "easeInOut" }}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default PortalLoader;
